module.exports = __webpack_public_path__ + "static/media/qr-code-tour.77f79dce.svg";